module.exports = __webpack_public_path__ + "img/Ident-2.a115e042.png";